export {
  MatchedOnType,
  InvoiceVersion,
  InvoiceDateProperty,
  InvoiceSource,
  DocumentType,
  InvoiceStatusFilter,
  PurchaseOrderStatus,
} from '@loadedhub/loaded-stock-api-sdk'

export {
  ActionType,
  ApprovalItemType,
  ShiftRequestType,
  ShiftRequestStatus,
  LeaveRequestStatus,
  UnavailabilityStatus,
  UnavailabilityRecordType,
  DaysOfTheWeek,
  EvaluationType,
  LeaveTypeType,
  EmployeeMatchType,
  PayrollSystem,
  DayOfWeek,
  ClassifierType,
  VariationActionType,
  VariationUnitType,
  LogicalOperatorType,
  PayClassificationType,
  PayClassificationAward,
  EmploymentType,
  RemunerationType,
  ShiftType,
  RuleType,
  PackageType,
  RuleOverrideType,
  RuleActionType,
  SelectedShifts,
  RulePayCodeType,
  RateType,
  EarningsType,
} from '@loadedhub/core-api-sdk'

// NoExport not included as do not want to it included in rule wizard
export enum RulePayCode {
  Allowance = 'Allowance',
  Award = 'Award',
  PublicHoliday = 'PublicHoliday',
  Overtime = 'Overtime',
  OnCost = 'OnCost',
  Other = 'Other',
}

// NoExport not included as do not want to it included in rule wizard
export enum RulePayCodeHumanReadable {
  Allowance = 'Allowance',
  Award = 'Award',
  PublicHoliday = 'Public Holiday',
  Overtime = 'Overtime',
  OnCost = 'On Cost',
  Other = 'Other',
}

export enum PayClassificationAwardHumanReadable {
  Custom = 'Custom',
  Restaurant = 'Restaurant Industry Award (RIA)',
  Hospitality = 'Hospitality Industry (General) Award (HIGA)',
  FastFood = 'Fast Food Industry Award (FFIA)',
  Wine = 'Wine Industry Award (WIA)',
}

export enum StockUnitType {
  Unknown = 'Unknown',
  Weight = 'Weight',
  Volume = 'Volume',
  Count = 'Count',
}

export enum CalendarType {
  Weekly = 'Weekly',
  Fortnightly = 'Fortnightly',
  TwiceMonthly = 'TwiceMonthly',
  Monthly = 'Monthly',
  FourWeekly = 'FourWeekly',
  Quarterly = 'Quarterly',
  Annual = 'Annual',
}

export enum PayRunStatus {
  Draft = 'Draft',
  Completed = 'Completed',
}

export enum PayRunEmployeeStatus {
  NotLinked = 'NotLinked',
  NotInLoaded = 'NotInLoaded',
  NotIncludedInPayRun = 'NotIncludedInPayrun',
  IncludedInPayRun = 'IncludedInPayrun',
}

export enum RelationshipType {
  Brother = 'Brother',
  Daughter = 'Daughter',
  Father = 'Father',
  Fiance = 'Fiance',
  Friend = 'Friend',
  Husband = 'Husband',
  Mother = 'Mother',
  Partner = 'Partner',
  Sister = 'Sister',
  Son = 'Son',
  Wife = 'Wife',
  Other = 'Other',
}

export enum ContactType {
  Emergency = 'Emergency',
}

export enum AccountingSystem {
  Xero = 'Xero',
}

export enum PayrollPayTypeSource {
  Custom = 'C',
  Default = 'D',
}

//TaxCode is a union of the available TaxCodes for each country
export type TaxCode = AU_TaxCode | NZ_TaxCode
export enum AU_TaxCode {
  ND = 'ND',
  M = 'M',
  MSL = 'M SL',
  ME = 'ME',
  MESL = 'MESL',
  SB = 'SB',
  SBSL = 'SB SL',
  S = 'S',
  SSL = 'S SL',
  SH = 'SH',
  SHSL = 'SHSL',
  ST = 'ST',
  STSL = 'ST SL',
  SA = 'SA',
  SASL = 'SASL',
  CAE = 'CAE',
  EDW = 'EDW',
  NSW = 'NSW',
  STC = 'STC',
  STCSL = 'STC SL',
}

export enum NZ_TaxCode {
  M = 'M',
  ME = 'ME',
  MSL = 'MSL',
  MESL = 'MESL',
  SB = 'SB',
  S = 'S',
  SH = 'SH',
  ST = 'ST',
  SA = 'SA',
}

export type Region = AU_Region | NZ_Region
export enum AU_Region {
  ACT = 'ACT',
  NSW = 'NSW',
  NT = 'NT',
  QLD = 'QLD',
  SA = 'SA',
  TAS = 'TAS',
  VIC = 'VIC',
  WA = 'WA',
}

export enum NZ_Region {
  Auckland = 'Auckland',
  Canterbury = 'Canterbury',
  HawkesBay = 'HawkesBay',
  Marlborough = 'Marlborough',
  NewPlymouth = 'NewPlymouth',
  Otago = 'Otago',
  Southland = 'Southland',
  Wellington = 'Wellington',
  Westland = 'Westland',
}

export enum KiwisaverContributionRate {
  TenPointFive = 10.5,
  SeventeenPointFive = 17.5,
  Thirty = 30,
  ThirtyThree = 33,
  ThirtyNine = 39,
}

export enum KiwisaverStatus {
  ActiveMember = 'ActiveMember',
  AutomaticallyEnrolled = 'AutomaticallyEnrolled',
  OptedIn = 'OptedIn',
  EmployedForLessThan28Days = 'EmployedForLessThan28days',
  NotRequiredToBeAutomaticallyEnrolled = 'NotRequiredToBeAutomaticallyEnrolled',
  NotEligible = 'NotEligible',
}

export enum ContributionOption {
  MakeContributions = 'MakeContributions',
  OnASavingsSuspension = 'OnASavingsSuspension',
}

export enum ConnectionAction {
  ProcessingConnection = 'ProcessingConnection',
  ResumeAfterConnection = 'ResumeAfterConnection',
  SelectXeroTenant = 'SelectXeroTenant',
}

export enum ThirdPartyConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  Unknown = 'Unknown',
}

export enum ThirdPartySystem {
  Xero = 'Xero',
  Square = 'Square',
  SquareConnector = 'SquareConnector',
}

export enum AuthModule {
  Time = 'Time',
  Stock = 'Stock',
}

export enum Country {
  NewZealand = 'New Zealand',
  Australia = 'Australia',
}

export enum CountryCode {
  NZ = 'NZ',
  AU = 'AU',
}

export enum AU_Province {
  ACT = 'AustralianCapitalTerritory',
  NSW = 'NewSouthWales',
  NT = 'NorthernTerritory',
  QLD = 'Queensland',
  SA = 'SouthAustralia',
  TAS = 'Tasmania',
  VIC = 'Victoria',
  WA = 'WesternAustralia',
}

export enum Locale {
  NZ = 'en-NZ',
  AU = 'en-AU',
  UK = 'en-GB',
  IE = 'en-IE',
}

export enum BinaryYesNo {
  Yes = 'Yes',
  No = 'No',
}

export enum ResidencyStatus {
  Australian = 'Australian',
  Foreigner = 'Foreigner',
}

export enum IncomeType {
  SalaryAndWages = 'SalaryAndWages',
  CloselyHeldPayees = 'CloselyHeldPayees',
  WorkingHolidayMaker = 'WorkingHolidayMaker',
}

export enum TaxScaleType {
  Regular = 'Regular',
  HorticulturistsOrShearers = 'HorticulturistsOrShearers',
  ActorsVarietyArtistsAndOtherEntertainers = 'ActorsVarietyArtistsAndOtherEntertainers',
  SeniorOrPensioners = 'SeniorOrPensioners',
  Foreign = 'Foreign',
}

export enum PayeesWorkingCondition {
  Promotional = 'Promotional',
  ThreeOrLessPerformancesPerWeek = 'ThreeOrLessPerformancesPerWeek',
  NoneOfThese = 'NoneOfThese',
}

export enum PensionersMaritalStatus {
  Couple = 'Couple',
  IllnessSeparatedCouple = 'IllnessSeparatedCouple',
  Single = 'Single',
}

export enum TaxFileNumberExemptionType {
  Pensioner = 'Pensioner',
  UnderEighteen = 'UnderEighteen',
  TFNNotQuoted = 'TFNNotQuoted',
  AwaitingTFN = 'AwaitingTFN',
}

export enum PosSystem {
  Cloudpos = 'Cloudpos',
}

export enum SuperFundType {
  Regulated = 'Regulated',
  SMSF = 'SMSF',
}

export enum AccessType {
  Standalone = 'Standalone',
}

export enum RuleSource {
  Managed = 'Managed',
  Custom = 'Custom',
  UserDefined = 'UserDefined',
  Override = 'Override',
}

export enum TooltipIconClass {
  Managed = 'fa fa-shield',
  Override = 'fa fa-user',
  Custom = 'fa fa-building',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  UserDefined = 'fa fa-building',
}

export enum RuleTypesHumanReadable {
  Managed = 'Managed',
  Custom = 'Custom',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  UserDefined = 'Custom',
  Override = 'Override',
}

export enum RemoveAdjustmentActionType {
  RemoveAdjustment = 'RemoveAdjustment',
  RemovePackage = 'RemovePackage',
  RemoveAllAdjustments = 'RemoveAllAdjustments',
  RemovePayCodeType = 'RemovePayCodeType',
}

export enum RuleActionTypeReadable {
  RemoveAdjustment = 'Remove an individual adjustment',
  RemovePackage = 'Remove a package',
  RemoveAllAdjustments = 'Remove all other adjustments',
  RemovePayCodeType = 'Remove a pay adjustment type',
}

export enum SelectedRosterSource {
  FromAnotherWeek = 'FromAnotherWeek',
  FromARosterTemplate = 'FromARosterTemplate',
}

export enum SelectedRosterSourceType {
  Week = 'Week',
  Day = 'Day',
}

export enum FeatureFlag {
  Alpha = 'alpha',
  Beta = 'beta',
  XeroNzEmployeeSync = 'xero-nz-employee-sync',
  CentralisedStaff = 'centralised-staff',
  TimeclockV2 = 'timeclock-beta',
  Onboarding = 'onboarding-beta',
  ShiftSwapping = 'shift-swapping',
}

// This enum has to remain with lower case and with hyphens as it is already used
// in JSON columns in pay adjustments and we are reusing the same for leave types
// and pay classifications
export enum ApplyTo {
  AllEmployees = 'all-employees',
  MatchingEmployees = 'only-employees',
}

export enum ApplyType {
  All = 'All',
  Any = 'Any',
}

export enum Operator {
  Equals = '=',
  DoesNotEqual = '!=',
}

export enum Browser {
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  Safari = 'Safari',
  Edge = 'Edge',
  InternetExplorer = 'Internet Explorer',
  Unknown = 'Unknown',
}

export enum ApprovalsRequestType {
  Leave = 'leave',
  Unavailability = 'unavailability',
  ShiftRequest = 'shift-request',
}

export enum CostMode {
  Forecast = 'forecast',
  Live = 'live',
}
